import { AccountInfo } from '@azure/msal-common';
import { HpDispatchFunction } from './actionTypes';

export function azureAdAuthSuccessAction(account?: AccountInfo) {
  return (dispatch: HpDispatchFunction<AccountInfo | undefined>): void => {
    dispatch({
      type: 'AZURE_AD_AUTHENTICATION_SUCCESS',
      payload: account
    });
  };
}
